import UserEventLog from "./user-event-log";
import {setMessage, setNotifications} from "../../system/app-slice";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";

export default function useUserEventLog() {
    const [loading, setLoading] = useState(false);
    const {user} = useSelector(state => state.auth);
    const [acceptDenyDialogVisible, setAcceptDenyDialogVisible] = useState(false);

    const dispatch = useDispatch();

    const getUserEventLogs = async ()=>{
        setLoading(true)
        const userEventLog = new UserEventLog();
        try {
            const query = {
                filters: {
                    $and:[
                        {owner:{$eq: user.id}},
                        {displayType:{$ne: "invisible"}},
                        // {isRead:{$eq: false}},
                        // {members: {id:{$eq: user.id}}}
                    ],
                },
                populate: {"audit_log":{fields:["after", "model"]}},
                fields:["displayType","title","message","createdAt", "isRead"],
                sort:["createdAt:desc"]

            }
            const _data = await userEventLog.getAll(query);

            setAcceptDenyDialogVisible(_data?.data?.filter(e=>e.isRead===false).some(e => e.displayType === "accept-deny-dialog"));
            let toasts = _data?.data?.filter(e=>e.isRead===false&&e.displayType === "toast");
            
            toasts.map(e=>{dispatch(setMessage({severity:"info", content:e.message}));})
            dispatch(setNotifications(_data?.data));
            setLoading(false)
        }catch (e) {
            setLoading(false)
        }
    }

    return {getUserEventLogs, loading, acceptDenyDialogVisible, setAcceptDenyDialogVisible};
}
